<template>
  <div class="s-vehicles-compare-bar--hide-sticky">
    <div class="page-container">
      <div class="row align-items-center">
        <div class="col-md-3">
          <div class="s-leasing-offers-compare__back">
            <button
              type="button"
              class="btn btn-link btn-icon-start"
              @click="onClickBack">
              <i class="icon-arrow-long-left"></i>
              {{ dictionary.backButtonText }}
            </button>
          </div>
        </div>
        <div class="col-md-9">
          <div class="row align-items-center">
            <div v-for="item in records" :key="item.id" class="col-md-4">
              <VehicleStickyBarCard
                :item="item"
                :records-length="records.length" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VehicleStickyBarCard from './VehicleStickyBarCard.vue'

export default {
  components: { VehicleStickyBarCard },

  props: {
    records: {
      required: true,
      type: Array,
    },
  },
  emits: ['click-back'],
  methods: {
    onClickBack() {
      this.$emit('click-back')
    },
  },
}
</script>
